export const listCountries = [
  { id: "1", name: "Afghanistan", code: "af", phonePrefix: "93" },
  { id: "2", name: "Albania", code: "al", phonePrefix: "355" },
  { id: "3", name: "Algeria", code: "dz", phonePrefix: "213" },
  { id: "4", name: "American Samoa", code: "as", phonePrefix: "1-684" },
  { id: "5", name: "Andorra", code: "ad", phonePrefix: "376" },
  { id: "6", name: "Angola", code: "ao", phonePrefix: "244" },
  { id: "7", name: "Anguilla", code: "ai", phonePrefix: "1-264" },
  { id: "8", name: "Antarctica", code: "aq", phonePrefix: "672" },
  { id: "9", name: "Antigua and Barbuda", code: "ag", phonePrefix: "1-268" },
  { id: "10", name: "Argentina", code: "ar", phonePrefix: "54" },
  { id: "11", name: "Armenia", code: "am", phonePrefix: "374" },
  { id: "12", name: "Aruba", code: "aw", phonePrefix: "297" },
  { id: "13", name: "Australia", code: "au", phonePrefix: "61" },
  { id: "14", name: "Austria", code: "at", phonePrefix: "43" },
  { id: "15", name: "Azerbaijan", code: "az", phonePrefix: "994" },
  { id: "16", name: "Bahamas", code: "bs", phonePrefix: "1-242" },
  { id: "17", name: "Bahrain", code: "bh", phonePrefix: "973" },
  { id: "18", name: "Bangladesh", code: "bd", phonePrefix: "880" },
  { id: "19", name: "Barbados", code: "bb", phonePrefix: "1-246" },
  { id: "20", name: "Belarus", code: "by", phonePrefix: "375" },
  { id: "21", name: "Belgium", code: "be", phonePrefix: "32" },
  { id: "22", name: "Belize", code: "bz", phonePrefix: "501" },
  { id: "23", name: "Benin", code: "bj", phonePrefix: "229" },
  { id: "24", name: "Bermuda", code: "bm", phonePrefix: "1-441" },
  { id: "25", name: "Bhutan", code: "bt", phonePrefix: "975" },
  { id: "26", name: "Bolivia", code: "bo", phonePrefix: "591" },
  { id: "27", name: "Bosnia and Herzegovina", code: "ba", phonePrefix: "387" },
  { id: "28", name: "Botswana", code: "bw", phonePrefix: "267" },
  { id: "29", name: "Brazil", code: "br", phonePrefix: "55" },
  {
    id: "30",
    name: "British Indian Ocean Territory",
    code: "io",
    phonePrefix: "246",
  },
  {
    id: "31",
    name: "British Virgin Islands",
    code: "vg",
    phonePrefix: "1-284",
  },
  { id: "32", name: "Brunei", code: "bn", phonePrefix: "673" },
  { id: "33", name: "Bulgaria", code: "bg", phonePrefix: "359" },
  { id: "34", name: "Burkina Faso", code: "bf", phonePrefix: "226" },
  { id: "35", name: "Burundi", code: "bi", phonePrefix: "257" },
  { id: "36", name: "Cambodia", code: "kh", phonePrefix: "855" },
  { id: "37", name: "Cameroon", code: "cm", phonePrefix: "237" },
  { id: "38", name: "Canada", code: "ca", phonePrefix: "1" },
  { id: "39", name: "Cape Verde", code: "cv", phonePrefix: "238" },
  { id: "40", name: "Cayman Islands", code: "ky", phonePrefix: "1-345" },
  {
    id: "41",
    name: "Central African Republic",
    code: "cf",
    phonePrefix: "236",
  },
  { id: "42", name: "Chad", code: "td", phonePrefix: "235" },
  { id: "43", name: "Chile", code: "cl", phonePrefix: "56" },
  { id: "44", name: "China", code: "cn", phonePrefix: "86" },
  { id: "45", name: "Christmas Island", code: "cx", phonePrefix: "61" },
  { id: "46", name: "Cocos Islands", code: "cc", phonePrefix: "61" },
  { id: "47", name: "Colombia", code: "co", phonePrefix: "57" },
  { id: "48", name: "Comoros", code: "km", phonePrefix: "269" },
  { id: "49", name: "Cook Islands", code: "ck", phonePrefix: "682" },
  { id: "50", name: "Costa Rica", code: "cr", phonePrefix: "506" },
  { id: "51", name: "Croatia", code: "hr", phonePrefix: "385" },
  { id: "52", name: "Cuba", code: "cu", phonePrefix: "53" },
  { id: "53", name: "Curacao", code: "cw", phonePrefix: "599" },
  { id: "54", name: "Cyprus", code: "cy", phonePrefix: "357" },
  { id: "55", name: "Czech Republic", code: "cz", phonePrefix: "420" },
  {
    id: "56",
    name: "Democratic Republic of the Congo",
    code: "cd",
    phonePrefix: "243",
  },
  { id: "57", name: "Denmark", code: "dk", phonePrefix: "45" },
  { id: "58", name: "Djibouti", code: "dj", phonePrefix: "253" },
  { id: "59", name: "Dominica", code: "dm", phonePrefix: "1-767" },
  {
    id: "60",
    name: "Dominican Republic",
    code: "do",
    phonePrefix: "1-809, 1-829, 1-849",
  },
  { id: "61", name: "East Timor", code: "tl", phonePrefix: "670" },
  { id: "62", name: "Ecuador", code: "ec", phonePrefix: "593" },
  { id: "63", name: "Egypt", code: "eg", phonePrefix: "20" },
  { id: "64", name: "El Salvador", code: "sv", phonePrefix: "503" },
  { id: "65", name: "Equatorial Guinea", code: "gq", phonePrefix: "240" },
  { id: "66", name: "Eritrea", code: "er", phonePrefix: "291" },
  { id: "67", name: "Estonia", code: "ee", phonePrefix: "372" },
  { id: "68", name: "Ethiopia", code: "et", phonePrefix: "251" },
  { id: "69", name: "Falkland Islands", code: "fk", phonePrefix: "500" },
  { id: "70", name: "Faroe Islands", code: "fo", phonePrefix: "298" },
  { id: "71", name: "Fiji", code: "fj", phonePrefix: "679" },
  { id: "72", name: "Finland", code: "fi", phonePrefix: "358" },
  { id: "73", name: "France", code: "fr", phonePrefix: "33" },
  { id: "74", name: "French Polynesia", code: "pf", phonePrefix: "689" },
  { id: "75", name: "Gabon", code: "ga", phonePrefix: "241" },
  { id: "76", name: "Gambia", code: "gm", phonePrefix: "220" },
  { id: "77", name: "Georgia", code: "ge", phonePrefix: "995" },
  { id: "78", name: "Germany", code: "de", phonePrefix: "49" },
  { id: "79", name: "Ghana", code: "gh", phonePrefix: "233" },
  { id: "80", name: "Gibraltar", code: "gi", phonePrefix: "350" },
  { id: "81", name: "Greece", code: "gr", phonePrefix: "30" },
  { id: "82", name: "Greenland", code: "gl", phonePrefix: "299" },
  { id: "83", name: "Grenada", code: "gd", phonePrefix: "1-473" },
  { id: "84", name: "Guam", code: "gu", phonePrefix: "1-671" },
  { id: "85", name: "Guatemala", code: "gt", phonePrefix: "502" },
  { id: "86", name: "Guernsey", code: "gg", phonePrefix: "44-1481" },
  { id: "87", name: "Guinea", code: "gn", phonePrefix: "224" },
  { id: "88", name: "Guinea-Bissau", code: "gw", phonePrefix: "245" },
  { id: "89", name: "Guyana", code: "gy", phonePrefix: "592" },
  { id: "90", name: "Haiti", code: "ht", phonePrefix: "509" },
  { id: "91", name: "Honduras", code: "hn", phonePrefix: "504" },
  { id: "92", name: "Hong Kong", code: "hk", phonePrefix: "852" },
  { id: "93", name: "Hungary", code: "hu", phonePrefix: "36" },
  { id: "94", name: "Iceland", code: "is", phonePrefix: "354" },
  { id: "95", name: "India", code: "in", phonePrefix: "91" },
  { id: "96", name: "Indonesia", code: "id", phonePrefix: "62" },
  { id: "97", name: "Iran", code: "ir", phonePrefix: "98" },
  { id: "98", name: "Iraq", code: "iq", phonePrefix: "964" },
  { id: "99", name: "Ireland", code: "ie", phonePrefix: "353" },
  { id: "100", name: "Isle of Man", code: "im", phonePrefix: "44-1624" },
  { id: "101", name: "Israel", code: "il", phonePrefix: "972" },
  { id: "102", name: "Italy", code: "it", phonePrefix: "39" },
  { id: "103", name: "Ivory Coast", code: "ci", phonePrefix: "225" },
  { id: "104", name: "Jamaica", code: "jm", phonePrefix: "1-876" },
  { id: "105", name: "Japan", code: "jp", phonePrefix: "81" },
  { id: "106", name: "Jersey", code: "je", phonePrefix: "44-1534" },
  { id: "107", name: "Jordan", code: "jo", phonePrefix: "962" },
  { id: "108", name: "Kazakhstan", code: "kz", phonePrefix: "7" },
  { id: "109", name: "Kenya", code: "ke", phonePrefix: "254" },
  { id: "110", name: "Kiribati", code: "ki", phonePrefix: "686" },
  { id: "111", name: "Kosovo", code: "xk", phonePrefix: "383" },
  { id: "112", name: "Kuwait", code: "kw", phonePrefix: "965" },
  { id: "113", name: "Kyrgyzstan", code: "kg", phonePrefix: "996" },
  { id: "114", name: "Laos", code: "la", phonePrefix: "856" },
  { id: "115", name: "Latvia", code: "lv", phonePrefix: "371" },
  { id: "116", name: "Lebanon", code: "lb", phonePrefix: "961" },
  { id: "117", name: "Lesotho", code: "ls", phonePrefix: "266" },
  { id: "118", name: "Liberia", code: "lr", phonePrefix: "231" },
  { id: "119", name: "Libya", code: "ly", phonePrefix: "218" },
  { id: "120", name: "Liechtenstein", code: "li", phonePrefix: "423" },
  { id: "121", name: "Lithuania", code: "lt", phonePrefix: "370" },
  { id: "122", name: "Luxembourg", code: "lu", phonePrefix: "352" },
  { id: "123", name: "Macau", code: "mo", phonePrefix: "853" },
  { id: "124", name: "Macedonia", code: "mk", phonePrefix: "389" },
  { id: "125", name: "Madagascar", code: "mg", phonePrefix: "261" },
  { id: "126", name: "Malawi", code: "mw", phonePrefix: "265" },
  { id: "127", name: "Malaysia", code: "my", phonePrefix: "60" },
  { id: "128", name: "Maldives", code: "mv", phonePrefix: "960" },
  { id: "129", name: "Mali", code: "ml", phonePrefix: "223" },
  { id: "130", name: "Malta", code: "mt", phonePrefix: "356" },
  { id: "131", name: "Marshall Islands", code: "mh", phonePrefix: "692" },
  { id: "132", name: "Mauritania", code: "mr", phonePrefix: "222" },
  { id: "133", name: "Mauritius", code: "mu", phonePrefix: "230" },
  { id: "134", name: "Mayotte", code: "yt", phonePrefix: "262" },
  { id: "135", name: "Mexico", code: "mx", phonePrefix: "52" },
  { id: "136", name: "Micronesia", code: "fm", phonePrefix: "691" },
  { id: "137", name: "Moldova", code: "md", phonePrefix: "373" },
  { id: "138", name: "Monaco", code: "mc", phonePrefix: "377" },
  { id: "139", name: "Mongolia", code: "mn", phonePrefix: "976" },
  { id: "140", name: "Montenegro", code: "me", phonePrefix: "382" },
  { id: "141", name: "Montserrat", code: "ms", phonePrefix: "1-664" },
  { id: "142", name: "Morocco", code: "ma", phonePrefix: "212" },
  { id: "143", name: "Mozambique", code: "mz", phonePrefix: "258" },
  { id: "144", name: "Myanmar", code: "mm", phonePrefix: "95" },
  { id: "145", name: "Namibia", code: "na", phonePrefix: "264" },
  { id: "146", name: "Nauru", code: "nr", phonePrefix: "674" },
  { id: "147", name: "Nepal", code: "np", phonePrefix: "977" },
  { id: "148", name: "Netherlands", code: "nl", phonePrefix: "31" },
  // { id: "149", name: "Netherlands Antilles", code: "an", phonePrefix: "599" },
  { id: "150", name: "New Caledonia", code: "nc", phonePrefix: "687" },
  { id: "151", name: "New Zealand", code: "nz", phonePrefix: "64" },
  { id: "152", name: "Nicaragua", code: "ni", phonePrefix: "505" },
  { id: "153", name: "Niger", code: "ne", phonePrefix: "227" },
  { id: "154", name: "Nigeria", code: "ng", phonePrefix: "234" },
  { id: "155", name: "Niue", code: "nu", phonePrefix: "683" },
  { id: "156", name: "North Korea", code: "kp", phonePrefix: "850" },
  {
    id: "157",
    name: "Northern Mariana Islands",
    code: "mp",
    phonePrefix: "1-670",
  },
  { id: "158", name: "Norway", code: "no", phonePrefix: "47" },
  { id: "159", name: "Oman", code: "om", phonePrefix: "968" },
  { id: "160", name: "Pakistan", code: "pk", phonePrefix: "92" },
  { id: "161", name: "Palau", code: "pw", phonePrefix: "680" },
  { id: "162", name: "Palestine", code: "ps", phonePrefix: "970" },
  { id: "163", name: "Panama", code: "pa", phonePrefix: "507" },
  { id: "164", name: "Papua New Guinea", code: "pg", phonePrefix: "675" },
  { id: "165", name: "Paraguay", code: "py", phonePrefix: "595" },
  { id: "166", name: "Peru", code: "pe", phonePrefix: "51" },
  { id: "167", name: "Philippines", code: "ph", phonePrefix: "63" },
  { id: "168", name: "Pitcairn", code: "pn", phonePrefix: "64" },
  { id: "169", name: "Poland", code: "pl", phonePrefix: "48" },
  { id: "170", name: "Portugal", code: "pt", phonePrefix: "351" },
  { id: "171", name: "Puerto Rico", code: "pr", phonePrefix: "1-787, 1-939" },
  { id: "172", name: "Qatar", code: "qa", phonePrefix: "974" },
  { id: "173", name: "Republic of the Congo", code: "cg", phonePrefix: "242" },
  { id: "174", name: "Reunion", code: "re", phonePrefix: "262" },
  { id: "175", name: "Romania", code: "ro", phonePrefix: "40" },
  { id: "176", name: "Russia", code: "ru", phonePrefix: "7" },
  { id: "177", name: "Rwanda", code: "rw", phonePrefix: "250" },
  { id: "178", name: "Saint Barthelemy", code: "bl", phonePrefix: "590" },
  { id: "179", name: "Saint Helena", code: "sh", phonePrefix: "290" },
  {
    id: "180",
    name: "Saint Kitts and Nevis",
    code: "kn",
    phonePrefix: "1-869",
  },
  { id: "181", name: "Saint Lucia", code: "lc", phonePrefix: "1-758" },
  { id: "182", name: "Saint Martin", code: "mf", phonePrefix: "590" },
  {
    id: "183",
    name: "Saint Pierre and Miquelon",
    code: "pm",
    phonePrefix: "508",
  },
  {
    id: "184",
    name: "Saint Vincent and the Grenadines",
    code: "vc",
    phonePrefix: "1-784",
  },
  { id: "185", name: "Samoa", code: "ws", phonePrefix: "685" },
  { id: "186", name: "San Marino", code: "sm", phonePrefix: "378" },
  { id: "187", name: "Sao Tome and Principe", code: "st", phonePrefix: "239" },
  { id: "188", name: "Saudi Arabia", code: "sa", phonePrefix: "966" },
  { id: "189", name: "Senegal", code: "sn", phonePrefix: "221" },
  { id: "190", name: "Serbia", code: "rs", phonePrefix: "381" },
  { id: "191", name: "Seychelles", code: "sc", phonePrefix: "248" },
  { id: "192", name: "Sierra Leone", code: "sl", phonePrefix: "232" },
  { id: "193", name: "Singapore", code: "sg", phonePrefix: "65" },
  { id: "194", name: "Sint Maarten", code: "sx", phonePrefix: "1-721" },
  { id: "195", name: "Slovakia", code: "sk", phonePrefix: "421" },
  { id: "196", name: "Slovenia", code: "si", phonePrefix: "386" },
  { id: "197", name: "Solomon Islands", code: "sb", phonePrefix: "677" },
  { id: "198", name: "Somalia", code: "so", phonePrefix: "252" },
  { id: "199", name: "South Africa", code: "za", phonePrefix: "27" },
  { id: "200", name: "South Korea", code: "kr", phonePrefix: "82" },
  { id: "201", name: "South Sudan", code: "ss", phonePrefix: "211" },
  { id: "202", name: "Spain", code: "es", phonePrefix: "34" },
  { id: "203", name: "Sri Lanka", code: "lk", phonePrefix: "94" },
  { id: "204", name: "Sudan", code: "sd", phonePrefix: "249" },
  { id: "205", name: "Suriname", code: "sr", phonePrefix: "597" },
  { id: "206", name: "Svalbard and Jan Mayen", code: "sj", phonePrefix: "47" },
  { id: "207", name: "Swaziland", code: "sz", phonePrefix: "268" },
  { id: "208", name: "Sweden", code: "se", phonePrefix: "46" },
  { id: "209", name: "Switzerland", code: "ch", phonePrefix: "41" },
  { id: "210", name: "Syria", code: "sy", phonePrefix: "963" },
  { id: "211", name: "Taiwan", code: "tw", phonePrefix: "886" },
  { id: "212", name: "Tajikistan", code: "tj", phonePrefix: "992" },
  { id: "213", name: "Tanzania", code: "tz", phonePrefix: "255" },
  { id: "214", name: "Thailand", code: "th", phonePrefix: "66" },
  { id: "215", name: "Togo", code: "tg", phonePrefix: "228" },
  { id: "216", name: "Tokelau", code: "tk", phonePrefix: "690" },
  { id: "217", name: "Tonga", code: "to", phonePrefix: "676" },
  { id: "218", name: "Trinidad and Tobago", code: "tt", phonePrefix: "1-868" },
  { id: "219", name: "Tunisia", code: "tn", phonePrefix: "216" },
  { id: "220", name: "Turkey", code: "tr", phonePrefix: "90" },
  { id: "221", name: "Turkmenistan", code: "tm", phonePrefix: "993" },
  {
    id: "222",
    name: "Turks and Caicos Islands",
    code: "tc",
    phonePrefix: "1-649",
  },
  { id: "223", name: "Tuvalu", code: "tv", phonePrefix: "688" },
  { id: "224", name: "U.S. Virgin Islands", code: "vi", phonePrefix: "1-340" },
  { id: "225", name: "Uganda", code: "ug", phonePrefix: "256" },
  { id: "226", name: "Ukraine", code: "ua", phonePrefix: "380" },
  { id: "227", name: "United Arab Emirates", code: "ae", phonePrefix: "971" },
  { id: "228", name: "United Kingdom", code: "gb", phonePrefix: "44" },
  { id: "229", name: "United States", code: "us", phonePrefix: "1" },
  { id: "230", name: "Uruguay", code: "uy", phonePrefix: "598" },
  { id: "231", name: "Uzbekistan", code: "uz", phonePrefix: "998" },
  { id: "232", name: "Vanuatu", code: "vu", phonePrefix: "678" },
  { id: "233", name: "Vatican", code: "va", phonePrefix: "379" },
  { id: "234", name: "Venezuela", code: "ve", phonePrefix: "58" },
  { id: "235", name: "Vietnam", code: "vn", phonePrefix: "84" },
  { id: "236", name: "Wallis and Futuna", code: "wf", phonePrefix: "681" },
  { id: "237", name: "Western Sahara", code: "eh", phonePrefix: "212" },
  { id: "238", name: "Yemen", code: "ye", phonePrefix: "967" },
  { id: "239", name: "Zambia", code: "zm", phonePrefix: "260" },
  { id: "240", name: "Zimbabwe", code: "zw", phonePrefix: "263" },
];

export const listMonths = [
  {
    id: "1",
    name: "January",
  },
  {
    id: "2",
    name: "February",
  },
  {
    id: "3",
    name: "March",
  },
  {
    id: "4",
    name: "April",
  },
  {
    id: "5",
    name: "May",
  },
  {
    id: "6",
    name: "June",
  },
  {
    id: "7",
    name: "July",
  },
  {
    id: "8",
    name: "August",
  },
  {
    id: "9",
    name: "September",
  },
  {
    id: "10",
    name: "October",
  },
  {
    id: "11",
    name: "November",
  },
  {
    id: "12",
    name: "December",
  },
];
